import {ListConfigs} from '../../sharedComponent/SearchList/SearchList.types'

export const LEADGENCUSTOMERLISTCONFIGS: ListConfigs[] = [
  {
    headerName: 'Customer Phone Number',
    apiFieldName: 'primaryPhoneNumber',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Link Status',
    apiFieldName: 'appInstalledStatus',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Sent Date/Time',
    apiFieldName: 'smsOptedTime',
    columnWidth: '150',
    type: 'LOCALTIME',
  },
  {
    headerName: 'Subscription Status',
    apiFieldName: 'isOpted',
    columnWidth: '150',
    type: 'SUBSCRIPTION',
  },
]
